import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import styles from './SectionWrapper.pcss';

const SectionWrapper = ({
    className,
    children,
    id,
    isFullBleedOnMobile, // removes horizontal spacing at small bp
    isHorizontalOnly, // removes vertical spacing
    isFullBleed, // for full bleed sections that need max-width
    isInset // uses horizontal/vertical values for product detail page
}) => {
    const wrapperClasses = cx(className, {
        [styles.fullBleedOnMobile]: isFullBleedOnMobile,
        [styles.horizontal]: !isInset && !isFullBleed,
        [styles.horizontalInset]: isInset,
        [styles.vertical]: !isInset && !isHorizontalOnly,
        [styles.verticalInset]: isInset && !isHorizontalOnly
    });

    return (
        <div className={wrapperClasses} id={id}>
            <div className={styles.content}>{children}</div>
        </div>
    );
};

SectionWrapper.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node.isRequired,
    id: PropTypes.string,
    isFullBleedOnMobile: PropTypes.bool,
    isHorizontalOnly: PropTypes.bool,
    isFullBleed: PropTypes.bool,
    isInset: PropTypes.bool
};

export default SectionWrapper;
